import Router from 'vue-router';

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import(/* webpackChunkName: "Home" */ '@/page/home')
  },
  // { path: '/', name: 'index', component: () => import(`@/page/index/index.vue`) },
  // { path: '/index', name: 'index', component: () => import(`@/page/index/index.vue`) },
  {
    path: '/intelligentlogistics',
    name: 'intelligentlogistics',
    component: () => import(`@/page/intelligentlogistics/intelligentlogistics.vue`)
  },
  {
    path: '/chargingFranchise',
    name: 'chargingFranchise',
    component: () => import(`@/page/chargingFranchise/chargingFranchise.vue`)
  },
  { path: '/keyCustomers', name: 'keyCustomers', component: () => import(`@/page/keyCustomers/keyCustomers.vue`) },
  { path: '/mobileApply', name: 'mobileApply', component: () => import(`@/page/mobile/mobile_apply.vue`) },
  { path: '/case', name: 'case', component: () => import(`@/page/case/case.vue`) },
  { path: '/antiCorruptionReport', name: 'antiCorruptionReport', component: () => import(`@/page/antiCorruptionReport/antiCorruptionReport.vue`) },
  { path: '/transportationEnterprises', name: 'transportationEnterprises', component: () => import(`@/page/transportationEnterprises/transportationEnterprises.vue`) },
  { path: '/individualDriver', name: 'individualDriver', component: () => import(`@/page/individualDriver/individualDriver.vue`) },
  { path: '/consignor', name: 'consignor', component: () => import(`@/page/consignor/consignor.vue`) },
  { path: '/parkServices', name: 'parkServices', component: () => import(`@/page/parkServices/parkServices.vue`) },
  { path: '/aboutUs', name: 'aboutUs', component: () => import(`@/page/mobile/about_us.vue`) },
  { path: '/projectPublic', name: 'projectPublic', component: () => import(`@/page/projectPublic/index.vue`) },
  { path: '/projectPublicDetail', name: 'projectPublicDetail', component: () => import(`@/page/projectPublic/detail.vue`) },
];
const router = new Router({
  routes,
  linkActiveClass: 'fontColor', //设置路由比标签选中颜色
  mode: 'history',
});
export default router;
